import React from 'react';
import styles from './EdofSection2.module.css';
const EdofSection2 = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                <div className={styles.LeftSection}>
                    <div className={styles.lifeImg}>
                        <img src='/Images/life_focus_new.webp' alt='life_focus_new' />
                        {/* <div className={styles.LifeInFocusText}>  
                            <h3>Life,</h3>
                            <h3>in focus</h3>
                        </div> */}
                    </div> 
                </div>
                <div className={styles.RightSection}>
                    <div className={styles.titleBlock}>
                        <img className={styles.mobileLogoImg} src='/Images/deseyne_logo_text.webp' alt='deseyne_logo_text' />
                        <h2 className={styles.subtitle}> Positive impacts
                            <br /> of Deseyne® EDOF</h2>
                        <h3 className={styles.subtitle}>technology on <span className={styles.diffrentColor}>your practice </span> and <span className={styles.diffrentColor}></span></h3>
                    </div>

                    <div className={styles.block}>
                        <h3>For your practice</h3>
                        <ul>
                            <li>Reduced chair time</li>
                            <li>Simplified adjustments</li>
                            <li>Elevated patient adoption</li>
                            <li>Less dropout</li>
                            <li>Improved sentiment</li>
                        </ul>
                    </div>

                    {/* Patients */}
                    <div className={styles.block}>
                        <h3>For your patients</h3>
                        <ul className={styles.UIBlock}>
                            <li>Higher satisfaction</li>
                            <li>Compliance</li>
                            <li>Comfort & Wearability</li>
                            <li>Supports eye health</li>
                            <li>
                                A third treatment option <br />beyond multifocal CLs <br /> & spectacles
                            </li>
                        </ul>
                    </div>

                </div>

            </div>

            <img className={styles.rightBottomImg} src='/Images/second_graph.png' alt='second_graph' loading="lazy" decoding="async" />
        </div>
    )
    
}

export default EdofSection2
